export default "__VITE_ASSET__mXbzqsI4__"